import { UrlQueryFilter } from "../../../../../shared/hooks/useUrlQuery";

export enum WorkLogPayerTabFilterStatus {
  ToApprove = "to-approve",
  InProgress = "in-progress",
  Approved = "approved",
  Rejected = "rejected"
}

export interface Filter extends UrlQueryFilter {
  payeeEngagementId?: string;
  /** The pay period the work log is connected to — `listWorkLogs` filters on it. */
  payPeriodId?: string;
  status?: WorkLogPayerTabFilterStatus;
}
